import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Layout from '../Layout';
import { AllLoader } from '../Ui/Loading';
const AppLoading = () => (_jsx(Layout, Object.assign({ isLoading: true, mainClassName: 'l-main' }, { children: _jsx(AllLoader, { isLoading: true }) })));
export default AppLoading;
